const NAME_PATTERN = /^[a-z]+([ -][a-z]+)*$/i;

const validateName = (name) => {
  const trimmed = name?.trim();

  if (!trimmed || trimmed.length < 2) return false;

  return NAME_PATTERN.test(trimmed);
};

export default validateName;
